import React from 'react';
export const ChannelLogo = ({ className, id = '', gtmTagVariable = '' }) => {
  return <i className={`flaticon-channel ${className} ${gtmTagVariable}`} />;
};

export const ClinicalVideoLogo = ({ className, id = '', gtmTagVariable = '' }) => {
  return (
    <i className={`flaticon-clinicalvideo ${className} ${gtmTagVariable}`} />
    // <svg
    //   version="1.1"
    //   id={`Layer_1_${ id } `}
    //   x="0px"
    //   y="0px"
    //   viewBox="0 0 10 10"
    //   xmlSpace="preserve"
    //   className={`${ className } ${ gtmTagVariable } `}
    // >
    //   <g>
    //     <path
    //       className={gtmTagVariable}
    //       d="M5.23,9.65c-0.24,0-0.49-0.02-0.73-0.06l0.11-0.66c0.21,0.03,0.42,0.05,0.62,0.05c1.06,0,2.04-0.41,2.77-1.16   C8.73,7.07,9.13,6.07,9.13,5c0-2.19-1.78-3.98-3.98-3.98C2.96,1.02,1.18,2.81,1.18,5c0,0.35,0.04,0.64,0.15,1.02L0.68,6.21   C0.56,5.77,0.5,5.42,0.5,5c0-1.24,0.48-2.41,1.36-3.29c0.88-0.88,2.05-1.36,3.29-1.36c1.24,0,2.41,0.48,3.29,1.36   C9.32,2.59,9.8,3.76,9.8,5c0,1.25-0.47,2.41-1.32,3.29C7.62,9.16,6.47,9.65,5.23,9.65z"
    //     />
    //     <path
    //       className={gtmTagVariable}
    //       d="M2.74,7.7l0.58,0l0,0.49l-0.56,0c0,0.1,0,0.2,0,0.3c0,0.03,0,0.14,0,0.17c-0.02,0.12,0.02,0.05-0.05,0.1H2.3   c-0.04-0.06-0.04,0.08-0.04-0.1l0-0.46l-0.56,0l0.01-0.48l0.55,0l0.01-0.56l0.48,0L2.74,7.7z M1.41,6.62   C1.3,6.69,1.24,6.74,1.13,6.83c-0.52,0.42-0.57,0.19-0.57,0.8c0,0.32,0,0.64,0,0.96c0,0.29-0.06,0.65,0.16,0.75   c0.11,0.05,3.47,0.08,3.62-0.02c0.21-0.14,0.11-1.4,0.11-1.75c0-0.24,0.05-0.27-0.09-0.39L2.77,6c-0.1-0.06-0.17-0.13-0.28-0.18   L1.41,6.62z"
    //     />
    //     <path
    //       className={gtmTagVariable}
    //       d="M0.11,7.19C0.34,7.24,0.5,7.03,0.75,6.85c0.19-0.14,1.63-1.23,1.79-1.28C2.64,5.65,2.7,5.72,2.83,5.8L4.3,6.87   C4.47,7,4.69,7.24,4.91,7.19c0.05-0.21-0.05-0.24-0.18-0.33L2.82,5.48c-0.1-0.07-0.2-0.17-0.3-0.22L0.61,6.64   C0.23,6.93,0.05,6.94,0.11,7.19L0.11,7.19z"
    //     />
    //     <path
    //       className={gtmTagVariable}
    //       d="M4.31,3.73C4.24,3.77,4.26,3.86,4.26,3.96v1.89c0,0.07-0.02,0.2,0.03,0.25c0.07,0.06,0.14-0.01,0.19-0.04   L5.3,5.54c0.06-0.04,0.11-0.07,0.17-0.1c0.22-0.15,0.45-0.27,0.66-0.43c0.07-0.05,0.11-0.1,0.02-0.18c-0.13-0.1-0.64-0.4-0.83-0.53   L4.66,3.89C4.55,3.81,4.39,3.69,4.31,3.73L4.31,3.73z"
    //     />
    //   </g>
    // </svg>
  );
};
// export const LiveCmeLogo = ({ className }) => (
//   <svg
//     version="1.1"
//     id="Layer_1"
//     x="0px"
//     y="0px"
//     viewBox="0 0 10 10"
//     xmlSpace="preserve"
//     className={className}
//   >
//     <path d="M0.82,7.01V0.92c0,0-0.02-0.25,0.25-0.25H9.1c0,0,0.25,0.02,0.25,0.25c0,0.24,0,6.08,0,6.08L0.82,7.01  L0.82,7.01z" />
//     <path
//       fill="#FFFFFF"
//       d="M1.52,7.01c0,0,0-5.23,0-5.45c0-0.2,0.14-0.18,0.25-0.18s6.67,0,6.67,0s0.21-0.03,0.21,0.24v5.39L1.52,7.01  L1.52,7.01z"
//     />
//     <path d="M0.15,6.99h9.69c0,0,0,2.34-0.89,2.34c-0.57,0-7.19,0-7.93,0C0.14,9.33,0.15,6.99,0.15,6.99z" />
//     <path
//       fill="#FFFFFF"
//       d="M0.92,7.69h8.2c0,0,0,0.99-0.56,0.99c-0.57,0-6.23,0-6.98,0C0.92,8.67,0.92,7.69,0.92,7.69z"
//     />
//     <path d="M8.1,8.23c0,0.11-0.09,0.19-0.19,0.19H6.18c-0.11,0-0.19-0.09-0.19-0.19V8.16c0-0.11,0.09-0.19,0.19-0.19h1.73  c0.11,0,0.19,0.09,0.19,0.19V8.23z" />
//     <path d="M4.1,8.23c0,0.11-0.09,0.19-0.19,0.19H2.18c-0.11,0-0.19-0.09-0.19-0.19V8.16c0-0.11,0.09-0.19,0.19-0.19h1.73  c0.11,0,0.19,0.09,0.19,0.19V8.23z" />
//     <path d="M3.07,2.42c0.62,0,0.48,0.69,0.48,0.69c0.13,0.14,0,0.24,0,0.24c-0.23,0.1,0.04,0.32,0.04,0.32H3.34  c-0.04,0-0.05,0.06-0.05,0.06C3.33,4,3.64,3.96,3.64,3.96C4,4,4,4.31,4,4.31l0.02,0.17c0,0.23-0.16,0.25-0.16,0.25  C3.74,4.76,3.07,4.77,3.07,4.77L3.07,2.42L3.07,2.42z M3.07,2.42c-0.62,0-0.48,0.69-0.48,0.69c-0.13,0.14,0,0.24,0,0.24  c0.24,0.12-0.04,0.32-0.04,0.32h0.25c0.04,0,0.05,0.06,0.05,0.06C2.82,4,2.51,3.96,2.51,3.96C2.15,4,2.14,4.31,2.14,4.31L2.12,4.48  c0,0.23,0.16,0.25,0.16,0.25c0.13,0.03,0.79,0.04,0.79,0.04L3.07,2.42L3.07,2.42z" />
//     <path d="M7.08,2.42c0.62,0,0.48,0.69,0.48,0.69c0.18,0.15-0.03,0.23-0.03,0.23C7.48,3.59,7.3,3.73,7.3,3.73  c0.02,0.21,0.35,0.23,0.35,0.23C8.01,4,8.02,4.31,8.02,4.31l0.02,0.17c0,0.23-0.16,0.25-0.16,0.25C7.75,4.76,7.08,4.77,7.08,4.77  L7.08,2.42L7.08,2.42z M7.08,2.42c-0.62,0-0.48,0.69-0.48,0.69C6.43,3.27,6.65,3.35,6.65,3.35c0.07,0.3,0.22,0.38,0.22,0.38  C6.84,3.96,6.52,3.96,6.52,3.96C6.16,4,6.15,4.31,6.15,4.31L6.13,4.48c0,0.23,0.16,0.25,0.16,0.25c0.13,0.03,0.79,0.04,0.79,0.04  L7.08,2.42L7.08,2.42z" />
//     <path d="M5.03,2.22c1.1,0,0.85,1.23,0.85,1.23s0.17,0.01,0.13,0.2C5.97,3.83,5.82,3.85,5.82,3.85  c-0.08,0.46-0.41,0.7-0.41,0.7c0.03,0.38,0.62,0.41,0.62,0.41c0.65,0.07,0.66,0.62,0.66,0.62l0.03,0.3c0,0.42-0.28,0.44-0.28,0.44  C6.22,6.38,5.03,6.4,5.03,6.4L5.03,2.22L5.03,2.22z M5.03,2.22c-1.1,0-0.85,1.23-0.85,1.23S4.01,3.48,4.06,3.67  c0.03,0.13,0.2,0.2,0.2,0.2C4.38,4.4,4.65,4.54,4.65,4.54C4.59,4.96,4.03,4.95,4.03,4.95C3.38,5.03,3.36,5.58,3.36,5.58l-0.03,0.3  c0,0.42,0.28,0.44,0.28,0.44C3.84,6.38,5.03,6.4,5.03,6.4V2.22z" />
//   </svg>
// );

export const LiveCmeLogo = ({ className, id = '', gtmTagVariable = '' }) => {
  return <i className={`flaticon-livecme ${className} ${gtmTagVariable} `} />;
};

export const MedwikiLogo = ({ className, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-medwiki ${className} ${gtmTagVariable} `} />
);
export const SpqLogo = ({ className, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-polls ${className} ${gtmTagVariable} `} />
);
export const TelemedLiteLogo = ({ className, gtmTagVariable = '' }) => (
  <i className={`flaticon-telemed ${className} ${gtmTagVariable} `} />
);
export const DiscussReferLogo = ({ className, gtmTagVariable = '' }) => (
  <i className={`flaticon-discussandrefer ${className} ${gtmTagVariable} `} />
);
export const EbookLogo = ({ className, gtmTagVariable = '' }) => (
  <i className={`flaticon-ebook ${className} ${gtmTagVariable} `} />
);
export const DashboardLogo = ({ className, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-home ${className} ${gtmTagVariable} `} />
  // <svg
  //   version="1.1"
  //   id={`Layer_1_${ id } `}
  //   x="0px"
  //   y="0px"
  //   viewBox="0 0 10 10"
  //   xmlSpace="preserve"
  //   className={`${ className } ${ gtmTagVariable } `}
  // >
  //   <path
  //     className={gtmTagVariable}
  //     d="M8.93,9.85H1.06V4.22c0-0.21,0.17-0.37,0.37-0.37s0.37,0.17,0.37,0.37V9.1h6.38V4.22  c0-0.21,0.17-0.37,0.37-0.37c0.21,0,0.37,0.17,0.37,0.37V9.85z"
  //   />
  //   <path
  //     className={gtmTagVariable}
  //     d="M6.12,9.85c-0.21,0-0.37-0.17-0.37-0.37V5.91h-1.5v3.57c0,0.21-0.17,0.37-0.37,0.37  c-0.21,0-0.37-0.17-0.37-0.37V5.16h3v4.31C6.5,9.68,6.33,9.85,6.12,9.85z"
  //   />
  //   <polygon
  //     className={gtmTagVariable}
  //     points="6.6,0.85 6.6,1.36 7.25,2 7.25,1.42 7.62,1.42 7.62,2.4 8.31,3.14 8.31,0.85 "
  //   />
  //   <path
  //     className={gtmTagVariable}
  //     d="M9.48,5.53c-0.1,0-0.2-0.04-0.27-0.12L5,1.02L0.78,5.41C0.64,5.56,0.4,5.56,0.25,5.42  C0.11,5.28,0.1,5.04,0.24,4.89l4.48-4.67C4.8,0.15,4.89,0.11,5,0.11l0,0c0.1,0,0.2,0.04,0.27,0.12l4.48,4.67  c0.14,0.15,0.14,0.39-0.01,0.53C9.66,5.49,9.57,5.53,9.48,5.53z"
  //   />
  // </svg>
);

export const ClirnetFullLogo = ({ className, id = '', gtmTagVariable = '' }) => (
  <svg
    version="1.1"
    id={`Layer_1_${id} `}
    x="0px"
    y="0px"
    viewBox="0 0 67.11 14.14"
    xmlSpace="preserve"
    className={className}
  >
    <g>
      <path
        fill="#234180"
        className={`${className} ${gtmTagVariable} `}
        d="M37.89,2.95v10.26h0.44V4.65l6.83,8.77V2.95h-0.44v7.49l-5.88-7.49H37.89z M54.95,3.39V2.95h-4.92v10.26h4.92   v-0.44h-3.46V8.12h3.46V7.67h-3.46V3.39H54.95z M64.17,2.95h-4.98v0.44h1.76v9.82h1.47V3.39h1.76V2.95z"
      />
      <polygon
        fill="#84C8B7"
        points="14,12.69 14,2.86 12.53,2.86 12.53,13.13 17.68,13.13 17.68,12.69  "
      />
      <path
        fill="#84C8B7"
        className={gtmTagVariable}
        d="M2.38,8.02c0-0.63,0.08-1.22,0.23-1.79c0.16-0.57,0.39-1.07,0.71-1.5c0.31-0.43,0.7-0.77,1.16-1.03   c0.46-0.26,0.99-0.38,1.6-0.38c0.37,0,0.72,0.04,1.05,0.12c0.33,0.09,0.63,0.19,0.9,0.32c0.28,0.13,0.52,0.27,0.74,0.42   c0.22,0.15,0.41,0.29,0.58,0.43l0.35-0.37c-0.19-0.17-0.4-0.34-0.65-0.52C8.82,3.56,8.53,3.4,8.21,3.25   C7.89,3.11,7.52,2.98,7.1,2.89c-0.42-0.1-0.89-0.15-1.42-0.15c-0.81,0-1.52,0.15-2.14,0.45S2.42,3.9,2,4.39   c-0.42,0.5-0.74,1.06-0.95,1.69C0.84,6.71,0.74,7.36,0.74,8.02c0,0.69,0.1,1.36,0.32,1.99c0.21,0.63,0.53,1.19,0.95,1.67   c0.42,0.48,0.95,0.86,1.58,1.14c0.63,0.28,1.37,0.43,2.21,0.43c0.49,0,0.93-0.04,1.33-0.12c0.4-0.09,0.77-0.19,1.09-0.33   c0.33-0.13,0.62-0.28,0.87-0.44c0.26-0.16,0.48-0.32,0.68-0.46l-0.35-0.38c-0.37,0.31-0.82,0.58-1.36,0.81   c-0.53,0.23-1.21,0.34-2.03,0.34c-0.58,0-1.09-0.12-1.54-0.37c-0.45-0.25-0.83-0.59-1.15-1.01c-0.31-0.42-0.55-0.92-0.72-1.48   C2.47,9.23,2.38,8.64,2.38,8.02L2.38,8.02z"
      />
      <path
        fill="#84C8B7"
        className={gtmTagVariable}
        d="M28.16,13.22V3.39h1.48c0.41,0,0.77,0.06,1.07,0.19c0.3,0.13,0.55,0.29,0.76,0.5c0.2,0.21,0.35,0.44,0.45,0.7   c0.1,0.26,0.15,0.52,0.15,0.79c0,0.64-0.18,1.17-0.54,1.58c-0.36,0.41-0.88,0.61-1.56,0.61h-1.51l3.15,5.45h1.7l-3.11-5.1   c0.57,0,1.05-0.07,1.45-0.2c0.4-0.13,0.73-0.31,0.98-0.54c0.25-0.23,0.44-0.5,0.56-0.81c0.12-0.31,0.18-0.64,0.18-0.99   c0-0.32-0.07-0.64-0.2-0.95c-0.14-0.31-0.34-0.59-0.6-0.84c-0.26-0.25-0.59-0.45-0.97-0.6c-0.39-0.15-0.82-0.23-1.31-0.23H26.7   v10.26H28.16z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFEDDC"
        className={gtmTagVariable}
        d="M22.3,4.54c0.06-0.09,0.14-0.29,0.1-0.39c-0.08,0.01-0.17,0.15-0.38,0.06c-0.12-0.05-0.23-0.18-0.22-0.3   c0.1-0.06,0.16-0.07,0.29-0.05c0.32,0.04,0.57,0.29,0.55,0.62c-0.03,0.42-0.48,0.64-0.8,0.76c-0.1,0.04-0.25,0.07-0.41,0.11   l-0.21-0.21l-0.2-0.19C21.5,4.88,22.02,4.94,22.3,4.54L22.3,4.54z M21.42,7.29l0.18,0.19l-0.18-0.06V7.29z M22.14,3.92   c-0.03-0.01-0.06,0.02-0.06,0.05C22.08,4,22.1,4.03,22.13,4.04c0.03,0,0.06-0.02,0.06-0.05C22.19,3.96,22.17,3.93,22.14,3.92   L22.14,3.92z"
      />
      <path fill="#84C8B7" d="M20.43,11.08c0.33,2.33,0.83,2.65,1.17,0V2.85h-1.17v7.4V11.08z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#84C8B7"
        className={gtmTagVariable}
        d="M21.08,0.52c0.51,0,0.92,0.41,0.92,0.92c0,0.51-0.41,0.92-0.92,0.92c-0.51,0-0.92-0.41-0.92-0.92   C20.16,0.93,20.57,0.52,21.08,0.52L21.08,0.52z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFEDDC"
        className={gtmTagVariable}
        d="M19.85,4.54c-0.06-0.09-0.14-0.29-0.1-0.39c0.08,0.01,0.17,0.15,0.38,0.06c0.12-0.05,0.23-0.18,0.22-0.3   c-0.1-0.06-0.16-0.07-0.29-0.05c-0.32,0.04-0.57,0.29-0.55,0.62c0.03,0.42,0.48,0.64,0.8,0.76c0.47,0.17,1.25,0.3,1.29,0.98v0.43   v0.5c0.43-0.28,0.58-1.02,0.38-1.49C21.3,4.61,20.33,5.18,19.85,4.54L19.85,4.54z M20,3.93c0.03-0.01,0.06,0.02,0.06,0.05   c0,0.03-0.02,0.06-0.04,0.06c-0.03,0.01-0.06-0.01-0.06-0.05C19.95,3.96,19.97,3.93,20,3.93L20,3.93z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFEDDC"
        className={gtmTagVariable}
        d="M21.59,9.58l0.02,0.42c0.47-0.39,0.36-0.96,0-1.18c-1.17-0.64-1.2-0.96-1.17-1.24V7.11   c-0.42,0.28-0.53,0.72-0.3,1.15c0.1,0.19,0.18,0.28,0.35,0.39C20.82,8.88,21.59,9.31,21.59,9.58L21.59,9.58z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFEDDC"
        className={gtmTagVariable}
        d="M20.43,10.17c-0.54,0.51,0.2,0.76,0.2,1.12c0,0,0.06-0.24,0-0.43C20.49,10.41,20.43,10.63,20.43,10.17   L20.43,10.17z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFEDDC"
        className={gtmTagVariable}
        d="M21.51,11.23c0.04-0.5,0.05-0.69-0.41-0.99c-0.71-0.46-0.67-0.56-0.67-0.88V8.82   c-0.62,0.35-0.48,1.16,0.09,1.44C21.28,10.64,21.2,10.43,21.51,11.23L21.51,11.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFEDDC"
        className={gtmTagVariable}
        d="M20.43,5.88c0.06,0.51,0.39,0.66,0.83,1c0.26,0.2,0.65,0.46,0.75,0.95c0.05,0.24-0.08,0.63-0.41,0.94   L21.6,7.99c0.04-0.33-0.7-0.77-0.93-0.93c-0.7-0.41-1.05-1.34-0.23-1.78V5.88z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFEDDC"
        className={gtmTagVariable}
        d="M21.92,2.27l0.02,1.23c0.36,0.03,0.54,0.32,0.78,0.03c-0.13-0.37-0.17-0.8-0.1-1.25   c-0.01,0.41,0.03,0.84,0.14,1.21c0.31,0.14,0.48,0.05,0.55-0.23c-0.25-0.36-0.43-0.78-0.44-1.18c0.05,0.35,0.22,0.77,0.45,1.12l0,0   c0.41,0.26,0.72,0.19,0.93-0.18c-0.41-0.15-0.8-0.41-1.08-0.82c0.31,0.36,0.71,0.62,1.1,0.78h0c0.36,0.07,0.56-0.04,0.62-0.33   c-0.55-0.04-1.14-0.22-1.51-0.5c0.24,0.18,0.92,0.39,1.52,0.47l0,0c0.51,0.05,0.93-0.09,1.23-0.48C24.97,2.06,24.12,2.31,23,1.89   C22.16,1.54,22.45,2.27,21.92,2.27L21.92,2.27z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFEDDC"
        className={gtmTagVariable}
        d="M20.18,2.34l-0.02,1.23c-0.36,0.03-0.54,0.32-0.78,0.03c0.13-0.37,0.17-0.8,0.1-1.25   c0.01,0.41-0.03,0.84-0.14,1.21c-0.31,0.14-0.49,0.05-0.55-0.23c0.25-0.36,0.43-0.79,0.44-1.18c-0.05,0.36-0.22,0.77-0.45,1.13v0   c-0.41,0.26-0.72,0.19-0.93-0.18c0.41-0.15,0.8-0.41,1.08-0.82c-0.31,0.36-0.71,0.62-1.1,0.78l0,0c-0.36,0.07-0.56-0.04-0.62-0.32   c0.55-0.05,1.14-0.22,1.51-0.5c-0.24,0.18-0.92,0.39-1.52,0.47l0,0c-0.51,0.05-0.93-0.09-1.23-0.48c1.15-0.09,2.01,0.16,3.12-0.26   C19.94,1.61,19.65,2.35,20.18,2.34L20.18,2.34z"
      />
      <text
        transform="matrix(1.0018 0 0 1 64.8057 3.9062)"
        fill="#141515"
        fontFamily="ArialMT"
        fontSize="2.6049px"
        className={gtmTagVariable}
      >
        ®
      </text>
    </g>
  </svg>
);
export const ClirnetIconLogo = ({ className, id = '', gtmTagVariable = '' }) => (
  <svg
    version="1.1"
    id={`Layer_1_${id} `}
    x="0px"
    y="0px"
    viewBox="0 0 10 10"
    xmlSpace="preserve"
    className={`${className} ${gtmTagVariable} `}
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1D4C6"
        className={gtmTagVariable}
        d="M1.31,1.86l0.01-0.01l0.01-0.01c0.01,0,0.01,0,0.01-0.01c0.01,0,0.01,0,0.01-0.01c0.01,0,0.01,0,0.01-0.01   c0.02,0,0.01,0,0.01-0.01c-0.02,0-0.02-0.01-0.01,0.01L1.34,1.81c-0.01,0-0.01,0-0.01,0.01L1.33,1.84L1.32,1.85L1.31,1.86L1.3,1.87   C1.26,1.9,1.26,1.91,1.24,1.94C1.11,2.08,0.95,2.31,0.85,2.46C0.72,2.68,0.61,2.9,0.5,3.16C0.05,4.24,0.08,5.57,0.52,6.67   c0.1,0.26,0.2,0.48,0.34,0.71c0.07,0.12,0.13,0.22,0.21,0.32C1.1,7.74,1.26,7.96,1.3,7.97C1.29,7.99,1.29,7.99,1.31,7.98   C1.31,8,1.32,8,1.33,8.01c0.02,0.02,0.01,0.01,0.02,0.01c0,0.02-0.01,0.01,0.01,0.01c0,0.02-0.01,0.01,0.01,0.01   c0,0.01-0.01,0.01,0.01,0.01c0,0.01,0,0.01,0.01,0.01L1.4,8.08c0,0.01,0,0.01,0.01,0.01L1.42,8.1l0.01,0.01l0.01,0.01   c0,0.01,0,0.01,0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01L1.5,8.19L1.51,8.2l0.01,0.01l0.01,0.01l0.01,0.01   l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01L1.6,8.28l0.01,0.01L1.62,8.3l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01   l0.01,0.01L1.66,8.34L1.65,8.33L1.64,8.32L1.63,8.31L1.62,8.3L1.61,8.29L1.6,8.28L1.59,8.27L1.58,8.26L1.57,8.26L1.56,8.25   L1.55,8.24L1.54,8.23L1.53,8.22L1.52,8.21L1.51,8.2L1.5,8.19L1.49,8.18L1.48,8.17L1.47,8.16L1.46,8.15L1.45,8.14L1.44,8.13   L1.43,8.12L1.43,8.11L1.42,8.1L1.41,8.09L1.4,8.08c0-0.01,0-0.01-0.01-0.01c0-0.01,0-0.01-0.01-0.01c0-0.01,0-0.01-0.01-0.01   c0-0.02,0.01-0.01-0.01-0.01c0-0.02,0.01-0.01-0.01-0.01c0-0.01-0.01-0.02-0.02-0.02c0,0-0.01-0.01-0.01-0.01   c-0.02-0.01,0,0-0.02-0.01c0-0.02,0.01-0.02-0.01-0.01c0.02-0.01,0.35,0.15,0.43,0.18c0.16,0.06,0.31,0.11,0.48,0.16   c0.34,0.1,0.73,0.16,1.11,0.17C3.69,8.5,4.04,8.37,4.35,8.25C4.48,8.19,5.14,7.89,5.2,7.82C5.08,7.85,4.71,7.77,4.59,7.74   C4.11,7.61,3.82,7.41,3.47,7.1C3.41,7.05,3.36,6.99,3.3,6.93C3.24,6.87,3.19,6.81,3.14,6.74c-0.7-0.92-0.79-2.21-0.25-3.26   C2.94,3.4,2.98,3.34,3.02,3.26l0.3-0.39c0.09-0.1,0.26-0.25,0.37-0.34c0.26-0.2,0.63-0.37,0.94-0.46C4.9,2.01,4.96,2,5.22,2.03   C5.17,1.97,4.5,1.65,4.37,1.6C4.06,1.47,3.71,1.34,3.33,1.35C2.94,1.36,2.56,1.42,2.21,1.52c-0.17,0.05-0.32,0.1-0.48,0.16   L1.3,1.87L1.31,1.86z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#214180"
        className={gtmTagVariable}
        d="M5.2,7.82C5.14,7.89,4.48,8.19,4.35,8.25C4.04,8.37,3.69,8.5,3.32,8.49C2.94,8.48,2.55,8.41,2.21,8.32   c-0.17-0.05-0.33-0.1-0.48-0.16C1.65,8.13,1.32,7.96,1.3,7.97c0.02-0.01,0.01-0.01,0.01,0.01c0.02,0.01,0,0,0.02,0.01   C1.33,8,1.33,8,1.33,8c0,0.01,0.01,0.02,0.02,0.02c0.02,0,0.01-0.01,0.01,0.01c0.02,0,0.01-0.01,0.01,0.01c0.01,0,0.01,0,0.01,0.01   c0.01,0,0.01,0,0.01,0.01c0.01,0,0.01,0,0.01,0.01l0.01,0.01L1.42,8.1l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01   l0.01,0.01l0.01,0.01l0.01,0.01L1.5,8.19L1.51,8.2l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01   l0.01,0.01L1.6,8.28l0.01,0.01L1.62,8.3l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01l0.01,0.01l0.11,0.1c0.04,0.03,0.08,0.07,0.11,0.1   l0.37,0.28c0.04,0.03,0.08,0.06,0.13,0.09C3.79,9.82,5.21,9.99,6.78,9.4c0.54-0.2,1.19-0.56,1.62-0.95   c0.13-0.12,0.23-0.23,0.33-0.32c0.04-0.03,0.06-0.08,0.1-0.11C9.07,7.76,9.35,7.31,9.5,6.97c0.09-0.2,0.16-0.41,0.22-0.64   c0.04-0.15,0.13-0.59,0.1-0.74L7.12,5.67l0.05,0.87C7.05,6.64,6.92,6.72,6.82,6.8C6.74,6.86,6.67,6.9,6.58,6.97   c-0.1,0.07-0.26,0.17-0.36,0.24C6.14,7.26,6.06,7.32,5.97,7.37C5.86,7.44,5.28,7.8,5.2,7.82L5.2,7.82z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#214180"
        className={gtmTagVariable}
        d="M2.39,0.93c0,0.02,0,0.01-0.01,0.01L2.36,0.95L2.34,0.96c-0.01,0.01,0.01,0-0.02,0.01c0,0-0.01,0.01-0.01,0.01   C2.29,1,2.31,0.99,2.29,1c-0.01,0.01,0,0-0.01,0.01L2.22,1.05C2.19,1.07,2.18,1.09,2.15,1.1c0.01,0.02,0.01,0.01-0.01,0.01   c0,0.02,0.01,0.01-0.01,0.01c0,0.02,0.01,0.01-0.01,0.02c0,0.02,0.01,0.01-0.01,0.01c-0.01,0.01,0,0.01-0.01,0.02   c0,0-0.01,0.01-0.01,0.01c-0.02,0.01,0,0-0.03,0.01c-0.01,0.01,0,0-0.01,0.02C2.01,1.21,2.05,1.18,2.02,1.2c0,0,0,0,0,0.01   L1.98,1.23c0,0.02,0,0.01-0.01,0.01c-0.01,0.02,0.01,0-0.01,0.02c0,0.02,0.01,0.01-0.01,0.01c0,0.02,0,0.01-0.01,0.01   c0,0.02,0.01,0.01-0.01,0.01L1.86,1.32c0,0.02,0.01,0.01-0.01,0.01c0,0.02,0.01,0.01-0.01,0.01l0.01,0c0,0.02,0,0.02-0.01,0.01   c0,0.01,0,0.01-0.01,0.01c0,0.02,0.01,0.01-0.01,0.01c0,0.02,0,0.01-0.01,0.01c0,0.02,0,0.01-0.01,0.01   c-0.01,0.01,0,0.01-0.01,0.02c0,0-0.01,0.01-0.01,0.01c0,0-0.01,0.01-0.02,0.02c0,0.01,0,0.01-0.01,0.01c0,0.02,0,0.01-0.01,0.01   c0,0.02,0,0.01-0.01,0.01c0,0.02,0,0.01-0.01,0.01c0,0.02,0,0.01-0.01,0.01c0,0.02,0.01,0.01-0.01,0.01c0,0.02,0.01,0.01-0.01,0.01   c0,0.02,0.01,0.01-0.01,0.01C1.63,1.54,1.54,1.62,1.51,1.65C1.48,1.68,1.4,1.77,1.36,1.79c0,0.02,0,0.01-0.01,0.01   c0,0.01,0.01,0.01-0.01,0.01c0,0.01,0,0.01-0.01,0.01c0,0.01,0.01,0.01-0.01,0.01L1.32,1.85L1.31,1.86L1.3,1.87l0.42-0.19   c0.16-0.06,0.31-0.11,0.48-0.16c0.35-0.1,0.73-0.16,1.12-0.17C3.71,1.34,4.06,1.47,4.37,1.6C4.5,1.65,5.17,1.97,5.22,2.03   C5.3,2.04,5.86,2.4,5.99,2.48L6.48,2.8c0.07,0.04,0.66,0.46,0.7,0.5L7.12,4.17l2.7,0.08C9.8,3.8,9.68,3.35,9.53,2.98   c-0.21-0.5-0.41-0.8-0.74-1.2c-0.18-0.21-0.38-0.39-0.6-0.56C7.93,1.01,7.6,0.8,7.24,0.63c-0.74-0.35-1.6-0.6-2.56-0.51   C4.22,0.16,3.8,0.26,3.42,0.41C3.23,0.48,3.05,0.56,2.88,0.65L2.39,0.93z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1D4C6"
        className={gtmTagVariable}
        d="M2.36,0.95L2.34,0.96c-0.02,0-0.01,0-0.04,0.01L2.29,1C2.25,1.01,2.17,1.07,2.15,1.1   c-0.02,0-0.02-0.01-0.01,0.01c-0.02,0-0.02-0.01-0.01,0.01c-0.03,0.01-0.01,0-0.01,0.02c-0.02,0-0.02-0.01-0.01,0.01   c-0.01,0-0.02,0.01-0.03,0.02c-0.03,0.02-0.01,0-0.02,0.02C2.02,1.19,2.03,1.19,2.02,1.2L1.98,1.23c-0.02,0-0.01-0.01-0.01,0.01   c-0.02,0-0.01,0-0.01,0.02c-0.02,0-0.02-0.01-0.01,0.01c-0.02,0-0.02-0.01-0.01,0.01c-0.02,0-0.01-0.01-0.01,0.01   C1.91,1.28,1.9,1.29,1.89,1.3L1.86,1.32c-0.02,0-0.01-0.01-0.01,0.01c-0.02,0-0.01-0.01-0.01,0.01c0.02,0,0.02,0,0.01-0.01   c0.02,0,0.01,0.01,0.01-0.01l0.06-0.05c0.02,0,0.02,0.01,0.01-0.01c0.02,0,0.02,0.01,0.01-0.01c0.02,0,0.02,0.01,0.01-0.01   c0.03-0.01,0.01,0,0.01-0.02c0.02,0,0.01,0.01,0.01-0.01L2.02,1.2c0,0,0,0,0-0.01c0.03-0.01-0.01,0.01,0.01-0.01   c0.01-0.01,0,0,0.01-0.02c0.02-0.01,0.01,0,0.03-0.01c0,0,0.01-0.01,0.01-0.01C2.09,1.14,2.09,1.14,2.1,1.14   c0.02,0,0.02,0.01,0.01-0.01c0.02,0,0.01,0,0.01-0.02c0.02,0.01,0.02,0.01,0.01-0.01c0.02,0,0.02,0.01,0.01-0.01   c0.03-0.01,0.04-0.03,0.07-0.05l0.05-0.04C2.28,1.01,2.28,1.01,2.29,1c0.03-0.01,0.01,0,0.03-0.02c0,0,0.01-0.01,0.01-0.01   c0.02-0.02,0,0,0.02-0.01L2.36,0.95l0.02-0.01c0.02,0,0.01,0.01,0.01-0.01L2.38,0.94L2.36,0.95z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1D4C6"
        className={gtmTagVariable}
        d="M1.82,1.36c-0.02,0-0.01-0.01-0.01,0.01c-0.02,0-0.01-0.01-0.01,0.01c-0.02,0-0.01-0.01-0.01,0.01L1.74,1.43   c-0.02,0-0.01-0.01-0.01,0.01c-0.02,0-0.01-0.01-0.01,0.01c-0.02,0-0.01-0.01-0.01,0.01c-0.02,0-0.01-0.01-0.01,0.01   c-0.02,0-0.01-0.01-0.01,0.01c-0.02,0-0.01-0.01-0.01,0.01c-0.02,0-0.01-0.01-0.01,0.01c-0.02,0-0.01-0.01-0.01,0.01   c0.02,0,0.02,0,0.01-0.01c0.02,0,0.01,0.01,0.01-0.01c0.02,0,0.01,0.01,0.01-0.01c0.02,0,0.01,0.01,0.01-0.01   c0.02,0,0.01,0.01,0.01-0.01c0.02,0,0.01,0.01,0.01-0.01c0.02,0,0.01,0.01,0.01-0.01c0.01,0,0.01,0.01,0.01-0.01   c0.01,0,0.02-0.01,0.02-0.02c0,0,0.01-0.01,0.01-0.01C1.78,1.39,1.78,1.4,1.78,1.39C1.8,1.39,1.8,1.4,1.8,1.38   c0.02,0,0.01,0.01,0.01-0.01C1.82,1.37,1.82,1.38,1.82,1.36c0.02,0,0.01,0.01,0.01-0.01c0.02,0,0.01,0.01,0.01-0.01   c-0.02,0-0.02,0-0.01,0.01C1.81,1.35,1.81,1.35,1.82,1.36L1.82,1.36z"
      />
    </g>
  </svg>
);
// export const Grlogo = ({ className }) => (
//   <svg
//     version="1.1"
//     id="Layer_1"
//     x="0px"
//     y="0px"
//     viewBox="0 0 10 10"
//     xmlSpace="preserve"
//     className={className}
//   >
//     <path d="M8.62,0.15H2.43c0,0-1.26-0.12-1.26,1.25s0,7.77,0,7.77s-0.05,0.68,0.9,0.68s6.55,0,6.55,0V9.17h-0.6V8.53h0.6  L8.62,0.15L8.62,0.15z" />
//     <path fill="#FFFFFF" d="M2.49,0.85v6.93H1.91V1.51C1.91,1.51,1.89,0.85,2.49,0.85z" />
//     <rect x="3.2" y="0.85" fill="#FFFFFF" width="4.71" height="6.94" />
//     <path
//       fill="#FFFFFF"
//       d="M2.12,8.53c0,0-0.21,0.01-0.21,0.32c0,0.31,0.21,0.28,0.21,0.28H7.3v-0.6L2.12,8.53L2.12,8.53z"
//     />
//     <path d="M4.02,4.21l1.55,1.61c0,0,0.68,0.39,1.19-0.14c0.52-0.55,0.22-1.02,0.22-1.02l-1.66-1.7  c0,0-0.53-0.32-1.08,0.25C3.74,3.73,4.02,4.21,4.02,4.21z" />
//     <path
//       fill="#FFFFFF"
//       d="M5.14,4.51l0.43-0.41L5.06,3.57c0,0-0.2-0.22-0.44,0C4.42,3.76,4.63,4,4.63,4L5.14,4.51z"
//     />
//     <path
//       fill="#FFFFFF"
//       d="M5.84,4.37L5.41,4.78l0.52,0.52c0,0,0.21,0.21,0.44-0.01c0.2-0.19-0.02-0.42-0.02-0.42L5.84,4.37z"
//     />
//   </svg>
// );

export const Grlogo = ({ className, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-grandround ${className} ${gtmTagVariable} `} />
);
export const TrainingLogo = ({ className, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-training ${className} ${gtmTagVariable} `} />
);

export const DoctubeLogo = ({ className, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-doctube ${className} ${gtmTagVariable} `} />
);

export const HelpAndSupport = ({ className, gtmTagVariable = '' }) => (
  <i className={`flaticon-question ${className} ${gtmTagVariable}  `} />
);
export const DiagnosisIcon = ({ className, gtmTagVariable = '' }) => {
  return <i className={`flaticon-ddx ${className} ${gtmTagVariable} `} />;
};
